import React from 'react';
import { LayoutProvider } from '../../contexts/layout/LayoutProvider';
import { LayoutClassBuilder } from './builders/LayoutClassBuilder';
import './Layout.css'; // optional CSS module or global
import type { LayoutTokenClasses } from './ModularTypes/LayoutSettings';
import type { SectionTokenClasses } from './ModularTypes/SectionSettings';
import type { UnitTokenClasses } from './ModularTypes/UnitSettings';
import type { MicroUnitTokenClasses } from './ModularTypes/MicroUnitSettings';

interface LayoutProps extends LayoutTokenClasses {
  children: React.ReactNode;
  context?: Record<
    string,
    UnitTokenClasses | SectionTokenClasses | MicroUnitTokenClasses
  >;
}

const Layout: React.FC<LayoutProps> = ({ children, ...props }) => {
  const className = LayoutClassBuilder.build(props);

  return (
    <LayoutProvider context={props.context || {}}>
      <div className={className}>{children}</div>
    </LayoutProvider>
  );
};

export default Layout;
